export default "__VITE_ASSET__BxU81knp__"